import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import Loader from '../../components/Loader';
import { toast } from 'react-toastify';
import ApiService from '../../services/ApiService';
import ImageUpload from '../../components/ImageUpload';


const BannerForm = () => {
  
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoader, setIsLoader] = useState(false);
  const [formData, setFormData] = useState({
    title: '',
    title_ar: '',
    image: '',
    image_url: '',
    link: '',
    status: true,
    sort_order: 0,
  });
  const [imageFile, setImageFile] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);



  useEffect(() => {
    if (id) {
      getSingleData();
    }
  }, [id]);
 

  const getSingleData = async () => {
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: 'GET',
        url: `admin/banners/${id}`,
      });
      const data = response.data;
      if (data.status) {
        const banner = data.data.banner;
        setFormData({
          title: banner.title || '',
          title_ar: banner.title_ar || '',
          image: banner.image || '',
          image_url: banner.image || '',
          link: banner.link || '',
          status: banner.status !== undefined ? banner.status : true,
          sort_order: banner.sort_order || 0,
        });
        setImageUrl(banner.image || null);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error(error);
      toast.error('Failed to load banner data');
    } finally {
      setIsLoader(false);
    }
  };



  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : (type === 'number' ? (value === '' ? 0 : parseInt(value)) : value),
    }));
  };
  
  const handleImageChange = (name, file) => {
    if (name === 'image') {
      setImageFile(file);
      if (file) {
        setImageUrl(URL.createObjectURL(file));
      } else {
        setImageUrl(null);
      }
    }
  };
 

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);

    try {
      const formDataToSend = new FormData();
      
      // Append all form fields
      Object.entries(formData).forEach(([key, value]) => {
        if (key !== 'image' && key !== 'image_url') {
          const valueToAppend = value !== null && value !== undefined ? String(value) : '';
          formDataToSend.append(key, valueToAppend);
        }
      });

      // Append image file if uploaded
      if (imageFile) {
        formDataToSend.append('image', imageFile);
      } else if (imageUrl && !imageFile) {
        // Keep existing URL if no new file uploaded
        formDataToSend.append('image_url', imageUrl);
      }

      const method = 'POST';
      const url = id ? `admin/banners/${id}/update` : 'admin/banners';

      const response = await ApiService.request({
        method,
        url,
        data: formDataToSend,
      });

      if (response.data.status) {
        toast.success(response.data.message);
        navigate('/banners');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Form submission failed:', error);
      toast.error('Failed to save banner. Please try again.');
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="d-flex flex-column flex-column-fluid">
      <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
        <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
          <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
            <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
              {id ? 'Edit' : 'Add New'} Banner
            </h1>
            <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
              <li className="breadcrumb-item text-muted">
                <Link to="/dashboard" className="text-muted text-hover-primary">Dashboard</Link>
              </li>
              <li className="breadcrumb-item">
                <span className="bullet bg-gray-400 w-5px h-2px"></span>
              </li>
              <li className="breadcrumb-item text-muted">
                <Link to="/banners" className="text-muted text-hover-primary">Banners</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="kt_app_content" className="app-content flex-column-fluid">
        <div id="kt_app_content_container" className="app-container container-xxl">
          <div className="card">
            <div className="card-body pt-0">
              <form onSubmit={handleSubmit} className="form fv-plugins-bootstrap5 fv-plugins-framework">
                <div className="row g-9 my-3">
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="required fs-6 fw-semibold mb-2">Title</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Banner Title"
                      required
                      name="title"
                      value={formData.title}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Title Arabic</label>
                    <input
                      type="text"
                      className="form-control form-control-solid"
                      placeholder="Enter Banner Title Arabic"
                      name="title_ar"
                      value={formData.title_ar}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Image</label>
                    <ImageUpload name="image" onImageChange={handleImageChange} defaultPreviewUrl={imageUrl || formData.image} />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Link (Optional)</label>
                    <input
                      type="url"
                      className="form-control form-control-solid"
                      placeholder="https://example.com"
                      name="link"
                      value={formData.link}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <label className="fs-6 fw-semibold mb-2">Sort Order</label>
                    <input
                      type="number"
                      className="form-control form-control-solid"
                      placeholder="0"
                      min="0"
                      name="sort_order"
                      value={formData.sort_order}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="col-md-6 fv-row fv-plugins-icon-container">
                    <div className="form-check form-switch form-check-custom form-check-solid mt-8">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="status"
                        id="status"
                        checked={formData.status}
                        onChange={handleChange}
                      />
                      <label className="form-check-label fs-6 fw-semibold" htmlFor="status">
                        Active
                      </label>
                    </div>
                  </div>


                </div>

             

                <div className="row g-9 my-3">
                  <div className="text-center">
                    <Link to={`/banners`} className="btn btn-light me-3">Back</Link>
                    <button type="submit" className="btn btn-base" disabled={isLoader}>
                      <span className="indicator-label">{isLoader ? <Loader size="20" color="white" text="Submitting" /> : 'Submit'}</span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerForm;
